export default {
  201: 'Evento creado con éxito',
};
